import axios from 'axios';

export const translateEndpoint = `${process.env.VUE_APP_API_ENDPOINT}/${process.env.VUE_APP_IPA_API_VERSION}`

export function requestIpaInfo(text, language, options = {}){
  return axios.post(translateEndpoint, {
    text: text,
    lang: language,
    mode: true,
    ...options
  })
}

export function requestIpa(text, language, options){
  return requestIpaInfo(text, language, options)
  .then((response)=>(response.data.ipa))
}


export const shortUrlEndpoint = `${process.env.VUE_APP_API_ENDPOINT}/short_url`

export function requestShortUrl(){
  return axios.post(shortUrlEndpoint, {
    path: window.location.search,
    text_only: false
  })
  .then((response)=>(response.data.short_url))
}

export function requestShortUrlPath(hash){
  return axios.get(`${shortUrlEndpoint}/${hash}`)
  .then((response)=>(response.data))
}
